import { render, staticRenderFns } from "./ViewUsers.vue?vue&type=template&id=8fbdf80e&scoped=true&"
import script from "./ViewUsers.vue?vue&type=script&lang=js&"
export * from "./ViewUsers.vue?vue&type=script&lang=js&"
import style0 from "./ViewUsers.vue?vue&type=style&index=0&id=8fbdf80e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbdf80e",
  null
  
)

component.options.__file = "ViewUsers.vue"
export default component.exports